import { Box, Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../types';
import { IAttachmentError } from '../../../common/reducers/types';
import { useResend } from '../../hooks/userActions';

type TryAgainButtonProps = Readonly<{
  error: IAttachmentError;
}>;

export const TryAgainButton: FC<TryAgainButtonProps> = ({ error }) => {
  const { t } = useTranslation();
  const [needResend, resend] = useResend(error.retryData?.messageId, error.retryData?.messageText);

  return needResend ? (
    <Box>
      <Button priority="secondary" size="small" skin="dark" onClick={resend}>
        {t<TLocalesKeys>('send_message_retry_cta_label')}
      </Button>
    </Box>
  ) : null;
};
